<template>
  <div class="container-fluid g-2 landingpage__container">    
    <div class="rowv g-2 master__headline">
      <div class="col">
        <slot name="header">
            <p>Anmeldung</p>
        </slot>
      </div>
    </div>

    <div class="row g-2">
      <div class="col">      
        <div>
          <img class="intro__image" src="img/background/intro_logo.svg" />
        </div>
      </div>
      <div class="col">
        <div class="row g-2 align-items-center login__content">
          <div class="col max__width">
            <form @submit.prevent="tryLogin()" class="form__signin">
              <div class="input-group space__surround">
              <span class="input-group-text" style="background-color:white;padding: 0.375rem 0.1rem"></span>
                <input
                  type="text"
                  id="userName"
                  class="form-control"
                  placeholder="Benutzername"
                  required
                  autocomplete="off"
                  spellcheck="false"
                  autocorrect="off"
                  autocapitalize="off"
                  v-model="login.UserName"
                  style="border-left: none;border-right: none"
                />
                <span class="input-group-text" style="background-color:white;padding: 0.375rem 0.1rem"></span>
              </div>


              <div class="input-group space__surround">
                <span class="input-group-text" style="background-color:white;padding: 0.375rem 0.1rem"></span>
                <input
                  :type="passwordType"
                  id="userPassword"
                  name="current-password"
                  class="form-control"
                  placeholder="Password"
                  autocomplete="current-password"
                  required
                  spellcheck="false"
                  autocorrect="off"
                  autocapitalize="off"
                  v-model="login.Password"   
                  style="border-left: none;border-right: none"
                  @paste.prevent   
                />
                <span class="input-group-text" style="background-color:white;">
                  <i :class="passwortClass" @click="togglePassword()" style="display:inline-block!important" id="togglePassword"></i>
                </span>              
              </div>
              <button class="btn btn-primary login__button space__surround">Login</button>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="row g-2">
      <div class="col">
        <div>
            <img class="intro__image" src="img/background/intro_hosting.svg" />
        </div>
      </div>
      <div class="col">
        <div>
          <img class="intro__image" src="img/background/intro_modul_uebersicht.svg" />
        </div>
      </div>
    </div>

  </div>
</template>

<script lang="ts">
import { AsyncRestClient } from "@/infrastructure/backend/async/AsyncRestClient";
import { MesageBusServiceForRoot } from "@/infrastructure/observables/messageBus";
import { reactive, ref, defineComponent } from "vue";
import { ProperytUriValidator } from "../Helper/propertyValidators";
import { UserProfile , UserProfileData} from "@/infrastructure/backend/userProfile";
import { serializeToJson } from "@/functional/datetimehelper";

export default defineComponent ({
  components: {},
  name: "UserLogin",
  inheritAttrs: false,    
  props: {    
    startUri: {
        type: String,
        default: null,
        require: true,
        validator: ProperytUriValidator
    },
    loginUri: {
        type: String,
        default: null,
        require: true,
        validator: ProperytUriValidator
    },    
  },
  setup(props) {
    
    const messageBus = MesageBusServiceForRoot.getMessageStateService()

    const login = reactive({
      UserName: "",
      Password: ""
    });

    const passwordType = ref("password");
    const passwortClass = ref("bi bi-eye");

    const raiseCommitMessage = (payLoad: string) => {           
      messageBus.changeMessageState({topic: "loginSuccess", source: "login", jsonPayload: payLoad})      
    }
    

    async function tryLogin() {
        const startClient = AsyncRestClient.Create(false);
        if (startClient.isFailure) return;

        const startResult = await startClient
            .getValue()
            .exchangeForComponents<string, string>(process.env.VUE_APP_API + props.startUri, '');   
        if (startResult.isFailure) return;

        const client = AsyncRestClient.Create(true);
        if (client.isFailure) return;

        const loginResult = await client
            .getValue()
            .exchangeForComponents<string, string>(process.env.VUE_APP_API + props.loginUri, serializeToJson(login));  

        if (loginResult.isFailure) return;
        const result = loginResult.getValue() as unknown as UserProfileData

        UserProfile.ChangeUserProfile(result.exposedUserId, result.personId, result.userDisplayName,  result.functionalRoles)

        raiseCommitMessage(serializeToJson(result));     
    }


    function togglePassword() {      
      if (passwordType.value === "password") {
        passwordType.value = "text";        
        passwortClass.value = "bi bi-eye-slash";
      } else {
        passwordType.value = "password";
        passwortClass.value = "bi bi-eye";
      }
    }

    return {      
        tryLogin,
        login,
        passwordType,
        passwortClass,    
        togglePassword,        
    };
  }
});
</script>

<style scoped lang="scss">

.intro__image {
  max-width: 340px;
}

.align__center {
  text-align: center !important;
}

.max__width {  
  max-width: 400px !important;
  width: 400px !important;
  
}

.space__surround {  
  margin-bottom: 20px;
  margin-top: 20px;
}



.login__content {
  text-align: center;
  justify-content: center;
 
}

.login__button {
  background-image: linear-gradient(90deg, rgb(0, 86, 150), rgb(14, 161, 196));
}

.login__container--password {
  border: #ced4da 1px solid;
  border-radius: 4px;
  
}

.login__input--password {
  border: none !important;
  display: inline-block;
  
}

.password__image {
  width: 10vw;
  margin-top: -0.125rem;
  vertical-align: -webkit-baseline-middle;
  background: transparent;
  color: black;
  display: inline-block;
}

.link__section {
  padding-top: 5vh;
  padding-left: 5vw;
  text-align: center;
  min-height: 14vh;
  height: 14h;
}

.form__control:focus {
  box-shadow: none;
}

.not__active {
  pointer-events: none;
  cursor: default;
}

a {
  padding: 0px;
  margin: 0px;
  padding-bottom: 2vh;
}

a:link {
  color: black;
}

/* visited link */
a:visited {
  color: black;
}

/* mouse over link */
a:hover {
  color: rgb(175, 8, 8);
}

/* selected link */
a:active {
  color: black;
}

.form__signin .btn {
  font-size: 80%;
  color: white;
  border-radius: 0.4rem;
  letter-spacing: 0.4rem;
  font-weight: bold;
  transition: all 0.2s;
  width: 100%;
}
</style>
